import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader } from "../../common/apis/authHeader";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import HandleError from "../../common/apis/HandleError";
import { apiVersion } from "../../common/apis/apiVersion";

export const SeriesAccTeamList = createAsyncThunk(
    "accumulator/SeriesAccTeamList",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/accumulator/team_list", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesBuyAccTeam = createAsyncThunk(
    "accumulator/SeriesBuyAccTeam",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/accumulator/add_team", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesPrizePoolTeamList = createAsyncThunk(
    "accumulator/SeriesPrizePoolTeamList",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/accumulator/prize_pool_list", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

// export const SeriesBuyPrizePoolTeam = createAsyncThunk(
//     "accumulator/SeriesBuyPrizePoolTeam",
//     async (values) => {
//         try {
//             const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/accumulator/add_prize_pool", values, {
//                 headers: authHeader()
//             });
//             return response.data;
//         } catch (error) {
//             HandleError(error.response.data)
//             return error.response.data
//         }
//     }
// );


export const MatchBuyPlayerAccTeam = createAsyncThunk(
    "accumulator/MatchBuyPlayerAccTeam",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/accumulator/add_plyaccumulator", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);


const initialState = {
    acc_team_list: {},
    acc_buy: {},
    prize_pool_team_list: {},
    // prize_pool_buy: {},
    player_acc_buy: {}
};

const accumulatorSlice = createSlice({
    name: "accumulator",
    initialState,
    reducers: {
        ResetAccTeamData: (state) => {
            state.acc_team_list = {};
        },
        ResetAccTeamBuy: (state) => {
            state.acc_buy = {};
        },
        ResetPrizePoolTeamData: (state) => {
            state.prize_pool_team_list = {};
        },
         ResetPrizePoolTeamBuy: (state) => {
             state.prize_pool_buy = {};
         },
        ResetAccPlayerBuy: (state) => {
            state.player_acc_buy = {};
        },
    },
    extraReducers: {
        [SeriesAccTeamList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesAccTeamList.fulfilled]: (state, { payload }) => {
            return { ...state, acc_team_list: payload, loading: false };
        },
        [SeriesAccTeamList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesBuyAccTeam.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesBuyAccTeam.fulfilled]: (state, { payload }) => {
            return { ...state, acc_buy: payload, loading: false };
        },
        [SeriesBuyAccTeam.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesPrizePoolTeamList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesPrizePoolTeamList.fulfilled]: (state, { payload }) => {
            return { ...state, prize_pool_team_list: payload, loading: false };
        },
        [SeriesPrizePoolTeamList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        // [SeriesBuyPrizePoolTeam.pending]: (state) => {
        //     return { ...state, loading: true };
        // },
        // [SeriesBuyPrizePoolTeam.fulfilled]: (state, { payload }) => {
        //     return { ...state, prize_pool_buy: payload, loading: false };
        // },
        // [SeriesBuyPrizePoolTeam.rejected]: (state) => {
        //     return { ...state, loading: false };
        // },

        [MatchBuyPlayerAccTeam.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MatchBuyPlayerAccTeam.fulfilled]: (state, { payload }) => {
            return { ...state, player_acc_buy: payload, loading: false };
        },
        [MatchBuyPlayerAccTeam.rejected]: (state) => {
            return { ...state, loading: false };
        },
    }
})

export const { ResetAccTeamData, ResetAccTeamBuy, ResetPrizePoolTeamData, ResetPrizePoolTeamBuy, ResetAccPlayerBuy } = accumulatorSlice.actions;
export const getAccTeamList = (state) => state.accumulator.acc_team_list;
export const getAccBuyData = (state) => state.accumulator.acc_buy;

export const getPrizePoolTeamList = (state) => state.accumulator.prize_pool_team_list;
// export const getPrizePoolBuyData = (state) => state.accumulator.prize_pool_buy;

export const getPlayerAccBuyData = (state) => state.accumulator.player_acc_buy;
export default accumulatorSlice.reducer;
